var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9734 2.95341H13.5505C14.1214 2.95341 14.6689 3.18021 15.0726 3.58391C15.4763 3.9876 15.7031 4.53513 15.7031 5.10605V11.0258H12.9734V12.2174L12.9719 12.2188H12.9731L9.40234 15.3324V15.3277L9.39853 15.3311H3.28659V11.0258H0.5V5.10605C0.5 4.53513 0.726795 3.9876 1.13049 3.58391C1.53419 3.18021 2.27294 2.95341 2.84386 2.95341H3.28659V0.800781H12.9734V2.95341ZM11.8955 12.2188H9.40234V14.2516L9.39853 14.2547H4.36291V8.335H11.8971V11.0258V12.2174L11.8955 12.2188ZM4.36291 2.95341H11.8971V1.8771H4.36291V2.95341ZM12.9734 6.18237H14.0498V5.10605H12.9734V6.18237Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPos);
export default __webpack_public_path__ + "static/media/icon-pos.2038a35d7b642c9b08f666ed581d61e9.svg";
export { ForwardRef as ReactComponent };